import {
  GET_ASSISTANCE_ROWS,
  GET_ASSISTANCE_ROWS_FULFILLED,
  GET_ASSISTANCE_ROWS_REJECTED,
  GET_MAP_DATA,
  GET_MAP_DATA_FULFILLED,
  GET_MAP_DATA_REJECTED,
  CREATE_ASSISTANCE_MARK,
  CREATE_ASSISTANCE_MARK_FULFILLED,
  CREATE_ASSISTANCE_MARK_REJECTED,
  UPDATE_ASSISTANCE_MARK,
  UPDATE_ASSISTANCE_MARK_FULFILLED,
  UPDATE_ASSISTANCE_MARK_REJECTED,
  DELETE_ASSISTANCE_MARK,
  DELETE_ASSISTANCE_MARK_FULFILLED,
  DELETE_ASSISTANCE_MARK_REJECTED,
  GET_CHANGE_SCHEDULE,
  GET_CHANGE_SCHEDULE_FULFILLED,
  GET_CHANGE_SCHEDULE_REJECTED,
  UPDATE_SCHEDULE,
  UPDATE_SCHEDULE_FULFILLED,
  UPDATE_SCHEDULE_REJECTED,
} from "./actionTypes";
import { openSnackbarAction } from "@icarius-common/snackbar/actions";
import { getLocalizedString, getErrorStringFromServerError } from "@icarius-localization/strings";
import {
  createAssistanceMarkAPI,
  deleteAssistanceMarkAPI,
  deleteDuplicatedAssistanceMarkAPI,
  getAssistanceAPI,
  getChangeScheduleAssistanceAPI,
  getMarksForMapAPI,
  updateAssistanceMarkAPI,
  updateChangeScheduleAssistanceAPI,
} from "@icarius-connection/api";

const errorHandler = (e, dispatch) => {
  let errorString = "";
  let duration = 5000;
  switch (e.response?.data?.status) {
    case "INVALID_MAX_WEEK_HOURS":
      errorString = getLocalizedString("scheduleChangeNotAllowedDueToExcessHours");
      duration = 15000;
      break;
    default:
      errorString = getErrorStringFromServerError(e);
      break;
  }
  dispatch(openSnackbarAction({ msg: errorString, severity: "error", duration: duration }));
}

const formatHasGPSCoordinates = (assistanceArray) => {
  return assistanceArray.map((item) => ({
    ...item,
    hasGPSCoordinates: item.hasGPSCoordinates ? getLocalizedString("yes") : getLocalizedString("no")
  }));
}

export const getAssistanceAction = () => async (dispatch) => {
  dispatch({ type: GET_ASSISTANCE_ROWS });
  try {
    let response = await getAssistanceAPI();

    let hasDuplicatedMarks = response.data && response.data.hasDuplicatedMarks;
    let dateFormat = response.data && response.data.date_format;
    let employeeList = response.data && response.data.employeeList;
    let openCalendarList = response.data && response.data.openCalendarList;
    let assistanceData = response.data && response.data.data;

    assistanceData = formatHasGPSCoordinates(assistanceData);

    dispatch({
      type: GET_ASSISTANCE_ROWS_FULFILLED,
      payload: {
        hasDuplicatedMarks,
        employeeList,
        openCalendarList,
        assistanceData,
        dateFormat,
      },
    });
    return response;
  } catch (e) {
    dispatch({ type: GET_ASSISTANCE_ROWS_REJECTED, payload: e });
    dispatch(openSnackbarAction({ msg: getErrorStringFromServerError(e), severity: "error" }));
    return e.response;
  }
};

export const createAssistanceMarkAction = (dataToSend) => async (dispatch) => {
  dispatch({ type: CREATE_ASSISTANCE_MARK });
  try {
    let response = await createAssistanceMarkAPI(dataToSend);

    let hasDuplicatedMarks = response.data && response.data.hasDuplicatedMarks;
    let employeeList = response.data && response.data.employeeList;
    let openCalendarList = response.data && response.data.openCalendarList;
    let assistanceData = response.data && response.data.data;

    assistanceData = formatHasGPSCoordinates(assistanceData);

    dispatch({
      type: CREATE_ASSISTANCE_MARK_FULFILLED,
      payload: {
        hasDuplicatedMarks,
        employeeList,
        openCalendarList,
        assistanceData,
      },
    });

    dispatch(openSnackbarAction({ msg: getLocalizedString("attendanceMarkCreatedSuccessfully"), severity: "success" }));
    return response;
  } catch (e) {
    dispatch({ type: CREATE_ASSISTANCE_MARK_REJECTED, payload: e });
    dispatch(openSnackbarAction({ msg: getErrorStringFromServerError(e), severity: "error" }));
  }
};

export const updateAssistanceMarkAction = (dataToSend) => async (dispatch) => {
  dispatch({ type: UPDATE_ASSISTANCE_MARK });
  try {
    let response = await updateAssistanceMarkAPI(dataToSend);

    let hasDuplicatedMarks = response.data && response.data.hasDuplicatedMarks;
    let employeeList = response.data && response.data.employeeList;
    let openCalendarList = response.data && response.data.openCalendarList;
    let assistanceData = response.data && response.data.data;

    assistanceData = formatHasGPSCoordinates(assistanceData);

    dispatch({
      type: UPDATE_ASSISTANCE_MARK_FULFILLED,
      payload: {
        hasDuplicatedMarks,
        employeeList,
        openCalendarList,
        assistanceData,
      },
    });

    dispatch(openSnackbarAction({ msg: getLocalizedString("attendanceMarkEditedSuccessfully"), severity: "success" }));
    return response;
  } catch (e) {
    dispatch({ type: UPDATE_ASSISTANCE_MARK_REJECTED, payload: e });
    dispatch(openSnackbarAction({ msg: getErrorStringFromServerError(e), severity: "error" }));
  }
};

export const deleteAssistanceMarkAction = (dataToSend) => async (dispatch) => {
  dispatch({ type: DELETE_ASSISTANCE_MARK });
  try {
    let response = await deleteAssistanceMarkAPI(dataToSend);

    let hasDuplicatedMarks = response.data && response.data.hasDuplicatedMarks;
    let assistanceData = response.data && response.data.data;

    assistanceData = formatHasGPSCoordinates(assistanceData);

    dispatch({
      type: DELETE_ASSISTANCE_MARK_FULFILLED,
      payload: {
        hasDuplicatedMarks,
        assistanceData,
      },
    });

    dispatch(openSnackbarAction({ msg: getLocalizedString("attendanceMarkDeletedSuccessfully"), severity: "success" }));
    return response;
  } catch (e) {
    dispatch({ type: DELETE_ASSISTANCE_MARK_REJECTED, payload: e });
    dispatch(openSnackbarAction({ msg: getErrorStringFromServerError(e), severity: "error" }));
  }
};

export const deleteDuplicatedAssistanceMarkAction = () => async (dispatch) => {
  dispatch({ type: DELETE_ASSISTANCE_MARK });
  try {
    let response = await deleteDuplicatedAssistanceMarkAPI();

    let hasDuplicatedMarks = response.data && response.data.hasDuplicatedMarks;
    let assistanceData = response.data && response.data.data;

    assistanceData = formatHasGPSCoordinates(assistanceData);

    dispatch({
      type: DELETE_ASSISTANCE_MARK_FULFILLED,
      payload: {
        hasDuplicatedMarks,
        assistanceData,
      },
    });

    dispatch(openSnackbarAction({ msg: getLocalizedString("duplicatedAttendanceMarksDeletedSuccessfully"), severity: "success" }));
    return response;
  } catch (e) {
    dispatch({ type: DELETE_ASSISTANCE_MARK_REJECTED, payload: e });
    dispatch(openSnackbarAction({ msg: getErrorStringFromServerError(e), severity: "error" }));
  }
};

export const getMarksForMapAction = (requestData) => async (dispatch) => {
  dispatch({ type: GET_MAP_DATA });
  try {
    let response = await getMarksForMapAPI({ requestData });
    let data = response.data && response.data.data;

    dispatch({
      type: GET_MAP_DATA_FULFILLED,
      payload: {
        data
      },
    });
    return response;
  } catch (e) {
    dispatch({ type: GET_MAP_DATA_REJECTED, payload: e });
    dispatch(openSnackbarAction({ msg: getErrorStringFromServerError(e), severity: "error" }));
  }
};

export const getChangeScheduleAssistanceAction = (code, date) => async (dispatch) => {
  dispatch({ type: GET_CHANGE_SCHEDULE });
  try {
    let response = await getChangeScheduleAssistanceAPI(`?code=${code}&date=${date}`);
    let status = response.data && response.data.status;
    let schedules = response.data && response.data.schedules;

    if (status !== "OK") {
      dispatch({ type: GET_CHANGE_SCHEDULE_REJECTED });
      dispatch(openSnackbarAction({ msg: getLocalizedString("defaultException"), severity: "error" }));
      return;
    }

    dispatch({
      type: GET_CHANGE_SCHEDULE_FULFILLED,
      payload: { schedules }
    });

    return response;
  } catch (e) {
    dispatch({ type: GET_CHANGE_SCHEDULE_REJECTED, payload: e });
    errorHandler(e, dispatch);
    return e.response;
  }
};

export const updateChangeScheduleAssistanceAction = (dataToSend) => async (dispatch) => {
  dispatch({ type: UPDATE_SCHEDULE });
  try {
    let response = await updateChangeScheduleAssistanceAPI(dataToSend);
    let status = response.data && response.data.status;

    if (status !== "OK") {
      dispatch({ type: UPDATE_SCHEDULE_REJECTED });
      dispatch(openSnackbarAction({ msg: getLocalizedString("defaultException"), severity: "error" }));
      return;
    }

    dispatch({
      type: UPDATE_SCHEDULE_FULFILLED,
    });

    dispatch(openSnackbarAction({ msg: getLocalizedString("shiftChangeCompletedSuccessfully"), severity: "success" }));
    return response;
  } catch (e) {
    dispatch({ type: UPDATE_SCHEDULE_REJECTED, payload: e });
    errorHandler(e, dispatch);
    return e.response;
  }
};